import { render } from "./accountPage.vue?vue&type=template&id=37eb2746"
import script from "./accountPage.vue?vue&type=script&lang=js"
export * from "./accountPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__